import { render, staticRenderFns } from "./AccountGatewaysTable.vue?vue&type=template&id=4fa2c3e7&scoped=true"
import script from "./AccountGatewaysTable.vue?vue&type=script&lang=js"
export * from "./AccountGatewaysTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2c3e7",
  null
  
)

export default component.exports